import { Checkbox } from '@chakra-ui/react';
import { memo } from 'react';

const MemoizedCheckbox = ({
 optionId,
 value,
 questionId,
 themeId,
 register,
 index,
 isViewMode = false,
}) => {
 return (
  <Checkbox
   key={optionId}
   value={value}
   id={`checkbox_question_${questionId}_${themeId}_${index}`}
   {...register(`checkbox_question_${questionId}_${themeId}.value`)}
   className='questionary-checkbox'
   isReadOnly={isViewMode}
  >
   {value}
  </Checkbox>
 );
};

export default memo(MemoizedCheckbox);
